import React, { useState ,useEffect } from "react";
import { IoMdClose } from "react-icons/io";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { toast } from "react-toastify";
import SummaryApi from "../common";
import { useSelector } from "react-redux";


const AdminAddProductToOrder = ({ orderId, type, onClose, callFunc }) => {
  const [buttonLoading, setButtonLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [price, setPrice] = useState("");
  const [quantity, setQuantity] = useState("");
  const [bonus, setBonus] = useState("");
  

  const user = useSelector(state => state?.user?.user);


  // Fetch products by type
  useEffect(() => {
    const fetchProducts = async () => {
      setLoading(true);
      try {
        const response = await fetch(`${SummaryApi.getAllProductsByType.url}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ type }),
        });

        const responseData = await response.json();

        if (responseData.success) {
          setProducts(responseData.data);
        } else {
          toast.error(responseData.message);
        }
      } catch (error) {
        toast.error("Failed to load products");
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [type]);

  const handleProductChange = (productId) => {
    const product = products.find((p) => p._id === productId);
    setSelectedProduct(product);
    setPrice(product?.price || "");
    setQuantity(1);
    setBonus(0);
  };
  const handlePriceChange = (value) => {
    const sanitizedValue = value !== "" ? Math.max(0, parseFloat(value) || 0) : 0; // Ensure price is a positive number or 0
    setPrice(sanitizedValue);
  };

  // Quantity Change Handler (ensure positive number, and limit it to available quantity)
  const handleQuantityChange = (value) => {
    const sanitizedValue = value !== "" ? Math.max(1, parseInt(value, 10) || 1) : 1; // Ensure quantity is positive and at least 1
    const availableQuantity = selectedProduct?.quantity || 0;
    const maxBouns = Math.max(0, availableQuantity - sanitizedValue); // Recalculate the max bouns based on the new quantity
  
    // Update the quantity
    setQuantity(Math.min(sanitizedValue, availableQuantity));
  
    // Adjust the bonus if it exceeds the new max
    setBonus((prevBonus) => Math.min(prevBonus, maxBouns));
  };

  const handleBounsChange = (value) => {
    const sanitizedValue = Number.isNaN(Number(value)) ? 0 : Number(value); // Ensure the value is a number, default to 0 if invalid
    const maxBouns = Math.max(0, (selectedProduct?.quantity || 0) - quantity); // Calculate the maximum allowable bouns
    setBonus(Math.min(sanitizedValue, maxBouns)); // Set the bouns to the sanitized value, limited by the max allowable
  };
  
  

  const handleAddProductToOrder = async () => {
    if (!selectedProduct || !quantity || !price ) {
      toast.error("من فضلك تاكد من اختيار المنتج والكمية والسعر والبونص قبل اضافة المنتج");
      return;
    }

    setButtonLoading(true);

    try {
       
      const response = await fetch(`${SummaryApi.addProductToOrder.url}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          orderId,
          productId: selectedProduct._id,
          unitPrice: parseFloat(price),
          quantity: parseInt(quantity, 10),
          bonus:parseInt(bonus,10),
          type:type,
          admin:user
        }),
      });

      const responseData = await response.json();

      if (responseData.success) {
        toast.success(responseData.message);
        onClose(); 
        callFunc(); 
      } else {
        toast.error(responseData.message);
      }
    } catch (error) {
      toast.error("An error occurred while adding the product");
    } finally {
      setButtonLoading(false);
    }
  };

  return (
    <div className="fixed top-0 bottom-0 left-0 right-0 w-full h-full z-10 flex justify-center items-center bg-slate-200 bg-opacity-50">
      <div className="mx-auto bg-white shadow-md p-4 w-full max-w-sm text-center rounded-md">
        <button
          className="block ml-auto text-gray-500 hover:text-gray-800"
          onClick={onClose}
        >
          <IoMdClose size={24} />
        </button>

        <h1 className="pb-4 text-lg font-medium text-gray-800">
          اضافة منتج الي الطلب الحالي
        </h1>

        {loading ? (
          <AiOutlineLoading3Quarters className="animate-spin text-3xl mx-auto" />
        ) : (
          <form onSubmit={(e) => e.preventDefault()}>
            {/* Product Dropdown */}
            <div className="mb-4">
              <label className="block mb-2">اختر المنتج</label>
              <select
                className="border p-2 rounded w-full"
                value={selectedProduct?._id || ""}
                onChange={(e) => handleProductChange(e.target.value)}
              >
                <option value="" disabled>
                  اختر المنتج
                </option>
                {products.map((product) => (
                  <option key={product._id} value={product._id}>
                    {product.productName} 
                  </option>
                ))}
              </select>
            </div>

            {/* Price Input */}
            <div className="mb-4">
              <label className="block mb-2"> 
                : السعر (السعر الحالي لهذا المنتج{selectedProduct?.price || "N/A"})
                </label>
              <input
                type="number"
                className="border p-2 rounded w-full"
                value={price}
                onChange={(e) => handlePriceChange(e.target.value)}
                min="0"
                placeholder="ادخل السعر"
              />
            </div>

            {/* Quantity Input */}
            <div className="mb-4">
              <label className="block mb-2">
                : الكمية (المتاح حاليا بالمخزن {selectedProduct?.quantity || "0"})
              </label>
              <input
                type="number"
                className="border p-2 rounded w-full"
                value={quantity}
                onChange={(e) => handleQuantityChange(e.target.value)}
                min="1"
                max={selectedProduct?.quantity || ""}
                placeholder="ادخل الكمية"
              />
            </div>
                        {/* Bonus Input */}
                        <div className="mb-4">
              <label className="block mb-2">
             
              : البونص ( أقصي حد مسموح للبونص{Math.max(0, (selectedProduct?.quantity || 0) - quantity || 0)})

              </label>
              <input
                type="number"
                className="border p-2 rounded w-full"
                value={bonus}
                onChange={(e) => handleBounsChange(e.target.value)}
                min="0"
                max={(selectedProduct?.quantity || 0) - quantity  || ""}
                placeholder="ادخل الكمية"
              />
            </div>

            {/* Submit Button */}
            <button
              className="py-2 px-6 bg-blue-500 hover:bg-blue-400 text-white rounded w-full"
              onClick={handleAddProductToOrder}
              disabled={buttonLoading}
            >
              {buttonLoading ? (
                <AiOutlineLoading3Quarters className="animate-spin inline" />
              ) : (
                "اضف المنتج"
              )}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default AdminAddProductToOrder;
